
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/longform/[slug]",
      function () {
        return require("private-next-pages/longform/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/longform/[slug]"])
      });
    }
  